/* eslint-disable */
import React, { FC, useContext } from 'react';
import injectSheet from 'react-jss';
import { useRouter } from 'Utils/router';

import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import { handleAccessibilityClick } from 'Utils/handleAccessibilityClick';

// Assets
import Caret from 'Assets/ui/caret.svg';
import styleSheet from './styles';

interface Props {
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  marginLeft?: string;
  marginRight?: string;
  paddingLeft?: string;
  paddingRight?: string;
  paddingTop?: string;
  paddingBottom?: string;
  visibility?: string;
  position?: string;
  classes?: any;
  caret?: boolean;
  sort?: any;
  display?: string;
  overflow?: string;
  listName?: string;
  loadAttributes?: string;
  items?: any;
}
const TableCell: FC<Props> = props => {
  const { sort } = props;
  const {
    helpers: { View, SortKeyCheck },
    actions: { track },
  } = useContext(ProductAnalyticsContext);
  const { location } = useRouter();
  /*
    sort is an object containg attributes and events.
    If sort is passed:
      div
        onClick
          set the click with the sort.events.onClickSortHandler.
          This will generate an anonymous function that will have the sort.sortKey passed to it.
      img
        className.  By default, the caret will have the caret class.
        However, if it's the activeColumn.  Ie, it was clicked, then based on the direction of the sort
        and the activeColumn.name matching the sort.sortKey, passed into the handler, an extra class
        caretRotateDown, will be passed.  This will rotate the active column caret 180deg from where it 
        was before it was clicked
        if the column has sort, but is not the active column, then don't add the caretRotateDown class
        if the column has sort and is the active column, then
  */

  const isSortButton =
    sort && sort.sortKey && sort.events && sort.events.onClickSortHandler;

  const handleClick = (event: any) => {
    if (!handleAccessibilityClick(event)) {
      return;
    }

    if (isSortButton) {
      // e.stopPropagation();  //This caused Radio buttons to not fire their click event.
      // Combined Analytics event tracking
      track('list_sorted', {
        screen: View(location.pathname),
        column_name: SortKeyCheck(sort.sortKey),
        direction: sort.activeColumn.direction === 'asc' ? 'desc' : 'asc',
      });
      sort.events.onClickSortHandler(sort.sortKey);
    }
  };

  const cellProps = isSortButton
    ? { role: 'button', tabIndex: 0, onClick: handleClick, onKeyDown: handleClick }
    : {};

  return (
    <div className={props.classes.cell} {...cellProps}>
      {props.children}
      {props.caret && sort && (
        <div
          className={`
      ${props.classes.caret}
      ${
        sort.activeColumn.name === sort.sortKey &&
        sort.activeColumn.direction !== 'desc'
          ? props.classes.caretRotateDown
          : ''
      }
      `}
        >
          {sort.activeColumn.name === sort.sortKey && <Caret />}
        </div>
      )}
    </div>
  );
};
export default injectSheet(styleSheet)(TableCell);
